var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalsauceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_132",
    "data-name": "Group 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.958,
    height: 82.222,
    viewBox: "0 0 99.958 82.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 99.958,
    height: 82.222,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M592.543,428.694a19.6,19.6,0,0,1-1.007,2,2.4,2.4,0,0,0,3.24-3.54,2.4,2.4,0,0,0-1.437-.678,19.467,19.467,0,0,1-.8,2.215",
    transform: "translate(-591.536 -426.479)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.471,
    cy: 0.477,
    r: 0.437,
    gradientTransform: "matrix(1.194, 0, 0, -1, 3.7, 9.534)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fc3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#1fc3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#0a89ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006cb6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M610.477,305.231v4.823a2.43,2.43,0,0,0,1.881-4.1,2.431,2.431,0,0,0-1.708-.729q-.086,0-.173.007",
    transform: "translate(-610.477 -305.224)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.446,
    cy: 0.497,
    r: 0.398,
    gradientTransform: "matrix(1.684, 0, 0, -1, 19.708, 16.696)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M596.557,499.155a1.72,1.72,0,0,0,.069,2.433,1.569,1.569,0,0,0,2.286.057,1.667,1.667,0,0,0,.088-2.494,1.709,1.709,0,0,0-1.211-.506,1.76,1.76,0,0,0-1.231.51",
    transform: "translate(-596.085 -498.645)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.508,
    cy: 0.476,
    r: 0.474,
    gradientTransform: "matrix(0.933, 0, 0, -1, -1.398, 7.813)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M656.81,377.966a1.728,1.728,0,0,0,.008,2.446,1.7,1.7,0,0,0,2.449-.023,1.655,1.655,0,0,0-.025-2.4,1.739,1.739,0,0,0-1.238-.532,1.679,1.679,0,0,0-1.194.505",
    transform: "translate(-656.307 -377.461)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.491,
    cy: 0.47,
    r: 0.47,
    gradientTransform: "matrix(0.952, 0, 0, -1, -1.117, 16.709)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M641.969,298.344a1.593,1.593,0,0,0,.018,2.4,1.627,1.627,0,0,0,2.379.023,1.669,1.669,0,0,0,.028-2.437,1.73,1.73,0,0,0-1.229-.528,1.609,1.609,0,0,0-1.2.538",
    transform: "translate(-641.43 -297.806)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.496,
    cy: 0.476,
    r: 0.476,
    gradientTransform: "matrix(0.94, 0, 0, -1, -1.347, 22.814)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbae17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#f7901a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4731e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M672.124,442.207a1.113,1.113,0,0,0-.027,1.5,1.047,1.047,0,0,0,1.49-.081.922.922,0,0,0-.033-1.414,1.038,1.038,0,0,0-.725-.316,1,1,0,0,0-.7.306",
    transform: "translate(-671.817 -441.901)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.497,
    cy: 0.473,
    r: 0.473,
    gradientTransform: "matrix(0.957, 0, 0, -1, -1.71, 19.927)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M700.03,394.089a.949.949,0,0,0,.049,1.383.851.851,0,0,0,1.318-.053.875.875,0,0,0-.014-1.332.982.982,0,0,0-.681-.274.944.944,0,0,0-.673.277",
    transform: "translate(-699.754 -393.812)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.5,
    cy: 0.473,
    r: 0.472,
    gradientTransform: "matrix(0.955, 0, 0, -1, -1.993, 27.67)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M672.944,344.226a.92.92,0,0,0,.02,1.342.861.861,0,0,0,1.328.006.922.922,0,0,0,.014-1.377.953.953,0,0,0-.66-.251.981.981,0,0,0-.7.281",
    transform: "translate(-672.663 -343.945)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.499,
    cy: 0.474,
    r: 0.475,
    gradientTransform: "matrix(0.95, 0, 0, -1, -2.133, 34.567)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M629.277,463.15a.974.974,0,1,0,1.391,1.363.948.948,0,0,0-.048-1.344.974.974,0,0,0-.689-.295.918.918,0,0,0-.654.276",
    transform: "translate(-628.995 -462.874)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.498,
    cy: 0.476,
    r: 0.475,
    gradientTransform: "matrix(0.955, 0, 0, -1, -1.832, 18.809)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M640.337,499.54a.941.941,0,0,0-.023,1.352.96.96,0,0,0,1.387.008.945.945,0,0,0-.028-1.342.916.916,0,0,0-1.337-.018",
    transform: "translate(-640.039 -499.26)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 0.5,
    cy: 0.475,
    r: 0.475,
    gradientTransform: "matrix(0.956, 0, 0, -1, -1.82, 13.911)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M551.382,469.285c-.78.6-.546.554.234-.074h-.009a.361.361,0,0,0-.225.074m.234-.074a.957.957,0,0,1,.6.327,3.03,3.03,0,0,0,4.662-.894,3.115,3.115,0,0,0-.837-3.762c-.072-.051-.144-.1-.215-.157a25.334,25.334,0,0,1-4.212,4.486",
    transform: "translate(-550.901 -464.725)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 0.5,
    cy: 0.456,
    r: 0.486,
    gradientTransform: "matrix(0.886, 0, 0, -1, -1.243, 6.186)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M607.258,358.993c0,.017-.007.034-.01.051,0-.017.007-.034.01-.051.038-.173.074-.346.107-.52-.033.174-.07.347-.107.52m.107-.52c.007-.037.014-.073.02-.11l-.02.11m.021-.116v0q.026-.138.049-.277-.023.139-.049.277m.3-4.483c0,.056.006.111.008.167.009.248.019.5.019.747,0,.044,0,.087,0,.13,0,.231-.008.46-.017.689,0,.042,0,.084-.007.126,0,0-.138,1.582-.169,1.8,0,0,0,.008,0,.012-.024.178-.052.355-.081.531,0,.025-.007.05-.011.075-.007.04-.014.08-.021.12s-.012.056-.017.084v0c-.007.037-.013.073-.02.11-.032.172-.067.343-.105.513l0,.008c0,.017-.007.034-.01.052.14.012.28.021.419.02a4.578,4.578,0,0,0,3.762-1.864,4.51,4.51,0,0,0,.186-5.175,4.351,4.351,0,0,0-3.654-2.1q-.138,0-.273,0Z",
    transform: "translate(-607.247 -349.922)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 0.474,
    cy: 0.5,
    r: 0.405,
    gradientTransform: "matrix(1.7, 0, 0, -1, 10.777, 7.549)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M561.787,89.21a1.245,1.245,0,0,0,.014,1.879,1.272,1.272,0,0,0,1.859.018,1.3,1.3,0,0,0,.022-1.905,1.352,1.352,0,0,0-.96-.412,1.259,1.259,0,0,0-.935.421",
    transform: "translate(-561.366 -88.789)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 0.496,
    cy: 0.476,
    r: 0.476,
    gradientTransform: "matrix(0.94, 0, 0, -1, -1.51, 49.168)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M584.841,85.432a1.543,1.543,0,0,0,.018,2.329,1.576,1.576,0,0,0,2.3.022,1.617,1.617,0,0,0,.027-2.361A1.677,1.677,0,0,0,586,84.911a1.559,1.559,0,0,0-1.159.521",
    transform: "translate(-584.319 -84.911)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 0.496,
    cy: 0.476,
    r: 0.476,
    gradientTransform: "matrix(0.94, 0, 0, -1, -1.266, 39.966)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M603.866,69.926a.51.51,0,0,0,.006.77.521.521,0,0,0,.762.007.535.535,0,0,0,.009-.781.555.555,0,0,0-.394-.169.516.516,0,0,0-.383.172",
    transform: "translate(-603.693 -69.754)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 0.496,
    cy: 0.476,
    r: 0.476,
    gradientTransform: "matrix(0.94, 0, 0, -1, -3.967, 124.385)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M586.473,61.47a.807.807,0,0,0,.009,1.218.824.824,0,0,0,1.205.012.845.845,0,0,0,.014-1.235.877.877,0,0,0-.623-.267.816.816,0,0,0-.606.273",
    transform: "translate(-586.2 -61.197)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 0.496,
    cy: 0.475,
    r: 0.476,
    gradientTransform: "matrix(0.94, 0, 0, -1, -2.435, 79.93)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M581.686,80.085a.309.309,0,0,0,0,.466.315.315,0,0,0,.461,0,.323.323,0,0,0,.006-.472.335.335,0,0,0-.238-.1.312.312,0,0,0-.232.1",
    transform: "translate(-581.581 -79.981)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 0.496,
    cy: 0.475,
    r: 0.476,
    gradientTransform: "matrix(0.94, 0, 0, -1, -6.319, 201.874)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M561.284,110.231a.28.28,0,0,0,0,.422.286.286,0,0,0,.417,0,.293.293,0,0,0,0-.428.3.3,0,0,0-.216-.093.282.282,0,0,0-.21.094",
    transform: "translate(-561.19 -110.137)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 0.496,
    cy: 0.475,
    r: 0.476,
    gradientTransform: "matrix(0.94, 0, 0, -1, -6.732, 209.841)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M365.486,146.391a2.372,2.372,0,0,1,.055-.32,2.372,2.372,0,0,0-.055.32q-.012.119-.012.237,0-.118.012-.237m-.351-3.553c-.19.27-.4.527-.606.788.205-.261.416-.518.606-.788m-5.09-3.3q.271.207.535.423-.264-.216-.535-.423m7.54-20.778h-.67a2.768,2.768,0,0,1-.442,3.583,2.726,2.726,0,0,1-3.986-.039,2.638,2.638,0,0,1-.436-3.544H360.58v20.279c-.168.163-.332.318-.493.312-.3-.012-.577-.366-.876-.553a20.332,20.332,0,0,0-7.586-2.959q-.56-.09-1.113-.149-.95-.1-1.88-.123h-.059c-.111,0-.221,0-.331,0-.419,0-.833.02-1.245.047a18.083,18.083,0,0,1,.42,2.019,14.952,14.952,0,0,1,.223,3.019,19.346,19.346,0,0,1-.345,3.626.532.532,0,0,1,.5-.253,11.134,11.134,0,0,1,9.154,4.1,11.315,11.315,0,0,1,.588,13.68,11.8,11.8,0,0,1-4.06,3.512,10.148,10.148,0,0,1-5.471,1.326,11.347,11.347,0,0,1-8.228-3.935,11.774,11.774,0,0,1-2.336-4.272.762.762,0,0,1,.093-.838q-.607.329-1.24.613l-.165.075a19.165,19.165,0,0,1-6.722,1.6h0c.023.1.045.191.07.285a19.5,19.5,0,0,0,4.42,8.143c.036.039.071.078.108.116a21.184,21.184,0,0,0,5.366,4.112q.733.381,1.49.7l.007,0c.23.1.463.187.7.275.1.037.2.071.3.107.129.046.257.091.387.134.1.028.2.058.307.083a26.368,26.368,0,0,0,4,.8,30.787,30.787,0,0,0,4.4-.126c.151-.008.3-.023.45-.037a19.455,19.455,0,0,0,13.133-8.545q.321-.488.614-1a19.071,19.071,0,0,0,1.8-4.218c.016-.054.033-.108.049-.162l.009-.032.018-.064v0q.105-.376.2-.756.029-.125.057-.25c0-.017.007-.033.01-.05h0c0-.017.007-.034.01-.051.046-.211.09-.423.129-.636.017-.092.034-.184.049-.277.029-.176.057-.353.081-.531,0,0,0-.008,0-.012.031-.22.056-.442.079-.665.033-.313.06-.627.079-.944,0-.019,0-.038,0-.057,0-.045,0-.091.007-.137V144.2a2.234,2.234,0,0,0-.4.068,2.234,2.234,0,0,1,.4-.068V118.764Z",
    transform: "translate(-329.408 -118.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 0.5,
    cy: 0.5,
    r: 0.428,
    gradientTransform: "matrix(1.461, 0, 0, -2, 0.541, 3.537)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M567.36,110.412a2.5,2.5,0,0,0,.028,3.774,2.554,2.554,0,0,0,3.734.036,2.6,2.6,0,0,0,.323-3.492.443.443,0,0,1-.631-.02.433.433,0,0,1-.025-.635,2.686,2.686,0,0,0-1.554-.507,2.524,2.524,0,0,0-1.876.843",
    transform: "translate(-566.514 -109.569)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 0.506,
    cy: 0.475,
    r: 0.476,
    gradientTransform: "matrix(0.959, 0, 0, -2, -0.534, 35.242)",
    xlinkHref: "#radial-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M605.2,424.575l-.018.064.018-.064v0",
    transform: "translate(-522.662 -366.681)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M607.243,416.827v0",
    transform: "translate(-524.443 -359.988)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M605.313,420.988c.053-.188.1-.378.149-.568-.047.19-.1.379-.149.566v0",
    transform: "translate(-522.776 -363.094)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M362.446,482.305c-.037-.038-.072-.078-.108-.116a19.5,19.5,0,0,0,6.964,4.926q-.757-.317-1.49-.7a21.182,21.182,0,0,1-5.366-4.112",
    transform: "translate(-312.932 -416.44)",
    fill: "#f47b20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M470.394,242.025q.93.018,1.88.123-.928-.106-1.88-.123",
    transform: "translate(-406.254 -209.024)",
    fill: "#f47b20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M467.587,241.995h-.052l.331,0c-.093,0-.186,0-.279,0",
    transform: "translate(-403.785 -208.998)",
    fill: "#f47b20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M414.16,518.613c-.234-.087-.466-.178-.7-.275.23.1.462.188.7.275",
    transform: "translate(-357.086 -447.66)",
    fill: "#f47b20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M606.454,417.141c-.015.064-.031.127-.047.19.016-.063.032-.127.047-.19q.029-.125.057-.25l.01-.047c0,.016-.006.031-.01.047q-.028.126-.057.25",
    transform: "translate(-523.721 -360.006)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M421.1,521.257l.044.012c-.13-.043-.258-.088-.387-.134.115.04.227.084.343.122",
    transform: "translate(-363.384 -450.076)",
    fill: "#f47b20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M607.183,416.824c0,.017-.006.033-.01.05,0-.016.006-.032.01-.047v0",
    transform: "translate(-524.382 -359.988)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M605.317,419.781c.053-.188.1-.377.149-.566.016-.063.032-.127.047-.19q-.09.381-.2.756",
    transform: "translate(-522.779 -361.889)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M62.755,58.944c.023-.184.051-.368.081-.55-.3.022-.6.033-.906.029A11.329,11.329,0,0,1,50.608,47.144a10.554,10.554,0,0,1,2.757-7.3,10.952,10.952,0,0,1,8.523-4,11.357,11.357,0,0,1,11.022,8.631l0,.019a18.692,18.692,0,0,1,7.8-2.254,1.808,1.808,0,0,1-.121-.293,27.853,27.853,0,0,0-1.263-3.43,18.808,18.808,0,0,0-3.6-5.03,18.394,18.394,0,0,0-9.28-5.177c-.421-.084-.526-.379-.253-.694.169-.189.4-.358.589-.547,3.219-3.22,6.418-6.46,9.659-9.68.316-.316.316-.484,0-.779-1.768-1.747-3.514-3.514-5.282-5.282-.232-.232-.484-.442-.737-.673-.4.358-.779.673-1.115,1.01q-7.45,7.418-14.878,14.857a1.333,1.333,0,0,1-.842.358c-.631.063-1.284.021-1.936.021q-14.078,0-28.178-.021c-.4,0-.463.168-.463.526.021,2.378.021,4.735,0,7.092,0,.442.105.589.568.589,7.113-.021,14.247-.021,21.359-.021a1.423,1.423,0,0,1,.484.147,2.181,2.181,0,0,1-.232.442q-6.976,6.976-13.931,13.91a4.183,4.183,0,0,1-.652.4.807.807,0,0,0,.231.231c.063,0,.126.042.189.042,3.493-.021,6.986-.042,10.48-.042,1.263,0,1.263.021,1.494,1.221,0,.042.021.063.021.105A24.415,24.415,0,0,0,44.7,56,19.315,19.315,0,0,0,51.3,63.347a.682.682,0,0,1,.316.884l-.631,1.831a10.885,10.885,0,0,1-3.451,4.672,11.589,11.589,0,0,1-4.819,2.273,10.479,10.479,0,0,1-6.229-.547,10.95,10.95,0,0,1-4.966-3.767,11.614,11.614,0,0,1-2.041-4.419,11.461,11.461,0,0,1,.337-5.955c.084-.253.168-.526.253-.779-.295-.021-.589-.042-.884-.042-2.378,0-4.735-.021-7.092,0a.657.657,0,0,0-.526.316,6.625,6.625,0,0,0-.4,1.894,19.18,19.18,0,0,0,.274,5.7c.231.821.295,1.683.589,2.462A31,31,0,0,0,23.8,71.786a18,18,0,0,0,5.661,6.145A16.846,16.846,0,0,0,34.826,80.5a24.074,24.074,0,0,0,4.04.8,16.164,16.164,0,0,0,6.1-.463,31.907,31.907,0,0,0,3.7-1.242,19.142,19.142,0,0,0,10.522-12.5c.105-.421.295-.736.821-.694.9.084,1.832.1,2.737.142.2-.007.288-.011.343-.015a21.242,21.242,0,0,1-.34-7.582",
    transform: "translate(-18.216 -9.201)",
    fill: "#000"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(80.658 58.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 4.229,
    height: 5.05,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(83.241 41.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 2.888,
    height: 4.864,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-2)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(81.279 67.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 3.907,
    height: 3.643,
    transform: "translate(-0.269 0)",
    fill: "url(#radial-gradient-3)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(89.49 51.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 3.868,
    height: 3.681,
    transform: "translate(-0.171 0)",
    fill: "url(#radial-gradient-4)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(87.462 40.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 3.881,
    height: 3.648,
    transform: "translate(-0.186 0)",
    fill: "url(#radial-gradient-5)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(91.605 60.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 2.304,
    height: 2.205,
    transform: "translate(-0.104 0)",
    fill: "url(#radial-gradient-6)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(95.414 53.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 2.159,
    height: 2.061,
    transform: "translate(-0.11 0)",
    fill: "url(#radial-gradient-7)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(91.721 46.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 2.151,
    height: 2.044,
    transform: "translate(-0.101 0)",
    fill: "url(#radial-gradient-8)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(85.766 63.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 2.128,
    height: 2.031,
    transform: "translate(-0.094)",
    fill: "url(#radial-gradient-9)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(87.272 68.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 2.128,
    height: 2.034,
    transform: "translate(-0.1 0)",
    fill: "url(#radial-gradient-10)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M458.378,242.05c.412-.027.827-.046,1.245-.047q-.629,0-1.249.039l0,.008h0",
    transform: "translate(-395.873 -209.005)",
    fill: "#2f80c3"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(75.118 63.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 6.882,
    height: 6.095,
    transform: "translate(-0.299 0)",
    fill: "url(#radial-gradient-11)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M469.963,242.02h0",
    transform: "translate(-405.882 -209.02)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M418.867,520.46c-.1-.035-.2-.07-.3-.107.1.037.2.071.3.107",
    transform: "translate(-361.495 -449.401)",
    fill: "#2f80c3"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(82.801 47.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 5.378,
    height: 9.143,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-12)"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M329.242,420.667c-.025-.094-.047-.19-.07-.285l-.037,0a18.336,18.336,0,0,0,4.527,8.424,19.5,19.5,0,0,1-4.42-8.143",
    transform: "translate(-284.255 -363.061)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M413.42,518.32l-.007,0,.007,0",
    transform: "translate(-357.042 -447.642)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M460.929,279.3a26.136,26.136,0,0,1-.346,3.626,19.343,19.343,0,0,0,.346-3.626",
    transform: "translate(-397.78 -241.215)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M381.17,403.611q-.607.329-1.24.613.632-.286,1.24-.613",
    transform: "translate(-328.125 -348.577)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M458.4,242.348c-.005,0,.23.862.42,2.019a18.05,18.05,0,0,0-.42-2.019",
    transform: "translate(-395.896 -209.303)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M329.427,410.258a19.164,19.164,0,0,0,6.722-1.6A19.168,19.168,0,0,1,329.427,410.258Z",
    transform: "translate(-284.508 -352.937)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M424.872,243.226a19.327,19.327,0,0,1,4.54-.86,19.32,19.32,0,0,0-4.54.86",
    transform: "translate(-366.939 -209.318)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M608.307,409.828c0-.025.007-.05.011-.075-.016.092-.032.185-.049.277.005-.028.012-.054.017-.082l.021-.12",
    transform: "translate(-525.329 -353.881)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M608.284,411.181c-.005.027-.012.054-.017.082v0c.005-.028.012-.056.017-.084",
    transform: "translate(-525.327 -355.115)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M607.257,416.446l-.01.051h0c0-.017.007-.034.01-.052Z",
    transform: "translate(-524.446 -359.662)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M607.452,411.783v0c-.038.214-.083.425-.129.636h0c.046-.21.089-.421.129-.634",
    transform: "translate(-524.512 -355.633)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M607.326,412.423c.047-.207.088-.416.127-.626-.039.213-.083.424-.129.634l0-.008",
    transform: "translate(-524.513 -355.647)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M610.484,380.641c.009-.229.016-.458.017-.689,0-.043,0-.086,0-.13,0-.251-.01-.5-.019-.747,0-.056-.006-.112-.008-.167v1.86c0-.042,0-.084.007-.126",
    transform: "translate(-527.236 -327.241)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M458.4,242.347h0",
    transform: "translate(-395.897 -209.302)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M607.247,416.818h0",
    transform: "translate(-524.446 -359.983)",
    fill: "#a3d420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M325.824,266.573h0a19.168,19.168,0,0,0,6.722-1.6l.165-.075q.632-.286,1.24-.613a19.288,19.288,0,0,0,9.757-13.325,26.152,26.152,0,0,0,.346-3.626,20.223,20.223,0,0,0-.223-3.019c-.19-1.156-.425-2.019-.42-2.019h0l0-.008a18.69,18.69,0,0,0-7.8,2.254c.07.287.13.577.177.87a11.14,11.14,0,0,1,.139,1.486,11.36,11.36,0,0,1-9.4,11.425q-.487.082-.983.12h-.012c-.03.182-.058.366-.081.55a21.247,21.247,0,0,0,.34,7.582l.037,0ZM343.38,242.3a19.324,19.324,0,0,0-4.54.86,19.316,19.316,0,0,1,4.54-.86",
    transform: "translate(-280.907 -209.253)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M458.386,242.348h0",
    transform: "translate(-395.881 -209.303)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M378.888,408.109l-.165.075.165-.075",
    transform: "translate(-327.083 -352.462)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M461.48,257.154a20.223,20.223,0,0,1,.223,3.019,14.952,14.952,0,0,0-.223-3.019",
    transform: "translate(-398.555 -222.09)",
    fill: "#2f80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M329.408,420.38h0Z",
    transform: "translate(-284.492 -363.059)",
    fill: "#2f80c3"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(76.545 12.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 3.034,
    height: 2.852,
    transform: "translate(-0.146 0)",
    fill: "url(#radial-gradient-13)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M598.151,113.252a.387.387,0,0,0,.006-.565.382.382,0,0,0-.563,0,.369.369,0,0,0,0,.558.377.377,0,0,0,.552.005",
    transform: "translate(-516.002 -97.215)",
    fill: "#0face3"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(79.674 11.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 3.761,
    height: 3.535,
    transform: "translate(-0.18 0)",
    fill: "url(#radial-gradient-14)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(82.316 9.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 1.244,
    height: 1.169,
    transform: "translate(-0.06 0)",
    fill: "url(#radial-gradient-15)"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(79.931 8.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 1.967,
    height: 1.849,
    transform: "translate(-0.094 0)",
    fill: "url(#radial-gradient-16)"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(79.301 10.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 0.752,
    height: 0.707,
    transform: "translate(-0.036)",
    fill: "url(#radial-gradient-17)"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(76.521 15.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 0.681,
    height: 0.64,
    transform: "translate(-0.033 0)",
    fill: "url(#radial-gradient-18)"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(44.916 16.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 38.325,
    height: 56.008,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-19)"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(77.247 14.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 5.975,
    height: 5.727,
    transform: "translate(-0.292 0)",
    fill: "url(#radial-gradient-20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalsauceLogo);
export default __webpack_public_path__ + "static/media/digitalsauce_logo.d134aa1f7769e532d2088ff5eef99199.svg";
export { ForwardRef as ReactComponent };